module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-center-down-b8ab952239c25e13547bed67c276f493.svg";